import {
  LayoutListDefinition,
  LAYOUT_LIST,
  TEXT,
  MEMORY_GAME_MATCH_BLOCK,
  MemoryGameBlockDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Quiz30: Translator = sequence => {
  return translate(sequence, item => {
    if (item.__typename === 'Question') {
      const listItem: LayoutListDefinition = {
        id: `${item.id}.text-list`,
        type: LAYOUT_LIST,
        values: {
          padded: true,
          align: 'center'
        },
        items: []
      };

      if (item.subtitle) {
        listItem.items.push({
          id: `${item.id}_subtitle`,
          type: TEXT,
          values: {
            value: item.subtitle,
            variant: 'sub_heading',
            icon: item?.icon
          },
          items: []
        });
      }

      if (item.title) {
        listItem.items.push({
          id: `${item.id}_title`,
          type: TEXT,
          values: {
            value: item.title,
            variant: 'heading2'
          },
          items: []
        });
      }

      if (item.body) {
        listItem.items.push({
          id: `${item.id}_body`,
          type: TEXT,
          values: {
            value: item.body,
            align: 'center'
          },
          items: []
        });
      }

      listItem.items.push({
        id: `${item.id}.memory-game`,
        type: MEMORY_GAME_MATCH_BLOCK,
        values: {
          termsItems: item.items?.map(({ id, value, subvalue }) => ({
            label: value,
            pairId: id,
            correctBorderColor: subvalue
          })),
          descriptionItems: item.items?.map(({ id, feedback, subvalue }) => ({
            label: feedback,
            pairId: id,
            correctBorderColor: subvalue
          }))
        }
      } as MemoryGameBlockDefinition);

      return listItem;
    }
    return null;
  });
};
